var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderTop'),_vm._m(0),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay-success-page"},[_c('div',{staticClass:"success-container"},[_c('div',{staticClass:"success-icon"},[_c('i',{staticClass:"el-icon-success"})]),_c('h1',{staticClass:"success-title"},[_vm._v("支付成功")]),_c('p',{staticClass:"success-tip"},[_vm._v("您的订单已支付成功，感谢您的使用！")])])])
}]

export { render, staticRenderFns }